import { render } from "./use-svg.vue?vue&type=template&id=2bdb37d6&scoped=true&ts=true"
import script from "./use-svg.vue?vue&type=script&lang=ts"
export * from "./use-svg.vue?vue&type=script&lang=ts"

import "./use-svg.vue?vue&type=style&index=0&id=2bdb37d6&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\2\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdb37d6"]])

export default __exports__